module.exports = __webpack_public_path__ + "images/2fd030948f15bbd8efc88595a9bc417a3.png";